'use strict';

var mcb = mcb || {};

mcb.hero = mcb.hero || new function () {

    this.init = function () {

        const elem = document.querySelector('.hero-slider');
        if (!elem) { return };

        const splide = new Splide(elem, {
            cover: true,
            pagination: false,
            heightRatio: 0.5,
            width: '100vw',
            type: 'loop',
            autoplay: true,
            interval: 10000
        });

        splide.on('arrows:updated', (prev, next) => {
            if (splide.length === 1) {
                prev.disabled = true;
                next.disabled = true;
            }
        });

        splide.mount();

    };
}();